const awsConfig = {
  cloudFormationTemplateURL: process.env.REACT_APP_CLOUDFORMATION_URL,
};

export default awsConfig;
